import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import { useSearchBox, useSortBy } from 'react-instantsearch';

import { CATALOGUE_INDEX, CATALOGUE_INDEX_ALPHABETICAL } from './catalogueIndexes';

const DEFAULT_INDEXES = { relevance: CATALOGUE_INDEX, alphabetical: CATALOGUE_INDEX_ALPHABETICAL };

/**
 * Mounts the sort-by widget the catalogue needs to search a replica, and realigns the
 * index on the query whenever something changed it without going through
 * `AlgoliaSearchBar` — clearing the refinements also clears the text, which would
 * otherwise leave an empty search on the relevance index.
 *
 * `indexes` overrides the relevance / alphabetical index names. When both are the same
 * index the widget exposes a single sort item.
 *
 * Switching index resets the pagination, so clearing the search box returns to the
 * first page of the alphabetical list.
 */
const AlgoliaIndexSwitch = ({ indexes = DEFAULT_INDEXES }) => {
    const { query } = useSearchBox();
    const items = useMemo(
        () =>
            indexes.alphabetical === indexes.relevance
                ? [{ label: 'relevance', value: indexes.relevance }]
                : [
                      { label: 'alphabetical', value: indexes.alphabetical },
                      { label: 'relevance', value: indexes.relevance },
                  ],
        [indexes.alphabetical, indexes.relevance],
    );
    const { currentRefinement, refine } = useSortBy({ items });

    const target = query.trim() ? indexes.relevance : indexes.alphabetical;

    useEffect(() => {
        if (currentRefinement !== target) refine(target);
    }, [currentRefinement, refine, target]);

    return null;
};

AlgoliaIndexSwitch.propTypes = {
    indexes: PropTypes.shape({ relevance: PropTypes.string.isRequired, alphabetical: PropTypes.string.isRequired }),
};

export default AlgoliaIndexSwitch;
